const MenuBC = [];

export default MenuBC;
